export default __webpack_public_path__ + "static/media/PR.FREQUENCY.THREE_ACTIVITIES_IN_WEEK_ACHIEVED.8470dd1f.jpg";